module.exports = __webpack_public_path__ + "k-icons.1637612034176.svg";